module.exports = __webpack_public_path__ + "static/media/undercover_00010.c8f2a1db.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/proj/undercover_00010.png
// module id = 65
// module chunks = 0